(function(){
  'use strict';

  document.querySelectorAll('script[data-section-id]').forEach(initSection);

  function initSection(scriptEl){
    const sectionId = scriptEl.getAttribute('data-section-id');
    const root = document.getElementById('rs-root-' + sectionId);
    if (!root || root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    const dataEl = document.getElementById('rs-product-data-' + sectionId);

    // ---- real text measurement (not an estimate) — a generic average
    // character-width ratio badly underestimates short, wide-letter words
    // like "WOMEN" (heavy on W/M), so measure actual rendered width instead.
    const measureSvg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    measureSvg.setAttribute('style','position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;');
    const measureText = document.createElementNS('http://www.w3.org/2000/svg','text');
    measureSvg.appendChild(measureText);
    document.body.appendChild(measureSvg);
    function measureTextWidth(text, fontSize, family, weight){
      measureText.setAttribute('font-size', fontSize);
      measureText.setAttribute('font-family', family);
      measureText.setAttribute('font-weight', weight);
      measureText.textContent = text;
      return measureText.getComputedTextLength();
    }
    function fitFontSizeByMeasurement(text, maxWidth, maxFontSize, minFontSize, family, weight){
      if (measureTextWidth(text, maxFontSize, family, weight) <= maxWidth) return maxFontSize;
      let lo = minFontSize, hi = maxFontSize, best = minFontSize;
      for (let i=0;i<14;i++){
        const mid = (lo+hi)/2;
        if (measureTextWidth(text, mid, family, weight) <= maxWidth){ best = mid; lo = mid; } else { hi = mid; }
      }
      return best;
    }

    let productData = { variants: [] };
    try { productData = JSON.parse(dataEl.textContent); } catch(e){ /* leave empty */ }

    // uploaded icon images (e.g. from Canva) — same load-check + fallback
    // pattern as the material photos: if a key is missing or the file 404s,
    // that icon just falls back to the drawn version in iconPath() below.
    const iconImagesEl = document.getElementById('rs-icon-images-' + sectionId);
    let iconImages = {};
    let iconImagesReady = Promise.resolve();
    if (iconImagesEl){
      try {
        const raw = JSON.parse(iconImagesEl.textContent);
        const checks = Object.keys(raw).map(key=>{
          return new Promise(resolve=>{
            const img = new Image();
            const done = (ok)=>{ if (ok) iconImages[key] = raw[key]; resolve(); };
            img.onload = ()=>done(true);
            img.onerror = ()=>done(false);
            img.src = raw[key];
            setTimeout(()=>done(false), 4000);
          });
        });
        iconImagesReady = Promise.all(checks);
      } catch(e){ /* falls back to drawn icons */ }
    }

    // ---- config (Common Room signs — Fitness Center, Pool, Business Center, etc.) ----
    const SHAPES = {
      rectangle: { label:'Rectangle' },
      arch:      { label:'Arch' },
      wavy:      { label:'Wavy' },
      bowed:     { label:'Bowed Edge' },
      diagonal:  { label:'Diagonal Cut' }
    };
    // Decorative treatments layered on top of whatever Shape is selected — modeled
    // after design capabilities (side stripes, offset shadows, two-tone splits,
    // banner graphics) rather than any one franchise's specific sign, and with no
    // logos — these are meant for independent hotels ordering their own design.
    const ACCENTS = {
      none:   { label:'None', needsColor:false },
      stripe: { label:'Side Stripe',        needsColor:true, incompatibleShapes:['circle','oval'] },
      bands:  { label:'Top & Bottom Bands', needsColor:true, incompatibleShapes:['circle','oval'] },
      shadow: { label:'Offset Shadow',      needsColor:true },
      split:  { label:'Two-Tone Split',     needsColor:true },
      banner: { label:'Banner Swoosh',      needsColor:true }
    };
    const ACCENT_COLORS = {
      charcoal: { label:'Charcoal', hex:'#2B2E33' },
      red:      { label:'Red',      hex:'#8C2F2A' },
      brass:    { label:'Brass',    hex:'#C6A05F' },
      sage:     { label:'Sage',     hex:'#6B7A5E' },
      custom:   { label:'Custom',   hex:null }
    };
    const MATERIALS = {
      standard:  { label:'1/8" Acrylic/Rowmark',              engrave:'#241D0F' },
      backplate: { label:'1/8" Acrylic/Rowmark + Backplate',  engrave:'#241D0F' }
    };
    const TYPEFACES = {
      serif: { label:'Classic Serif', family:"Georgia, 'Times New Roman', serif", weight:600 },
      sans:  { label:'Modern Sans',   family:"-apple-system, Helvetica, Arial, sans-serif", weight:700 },
      script:{ label:'Script',        family:"'Snell Roundhand', 'Brush Script MT', 'Segoe Script', cursive", weight:400, italic:false }
    };
    const SIZES = {
      standard: { label:'6" × 9" (ADA Standard)', w:6, h:9 },
      small:  { label:'Small',  w:8,  h:5 },
      medium: { label:'Medium', w:10, h:6 },
      large:  { label:'Large',  w:12, h:8 }
    };
    const MOUNTINGS = {
      flush:    { label:'Flush Wall-Mount' },
      standoff: { label:'Standoff Mount' }
    };
    const RESTROOM_TYPES = {
      men:    { label:'Men',    defaultLabel:'MEN' },
      women:  { label:'Women',  defaultLabel:'WOMEN' },
      unisex: { label:'Unisex', defaultLabel:'RESTROOM' }
    };
    const ACCESSIBLE_MODES = { off:{label:'Standard'}, on:{label:'+ Accessible Symbol'} };


    let state = {
      restroomType:'unisex', includeAccessible:'on',
      labelText:'RESTROOM', labelManual:false,
      shape:'rectangle', material:'standard', typeface:'sans',
      size:'standard', mounting:'flush',
      plateColor:'#2B2E33', textColor:'#F2ECDE', textColorManual:true,
      accent:'none', accentColor:'charcoal', accentCustomColor:'#8C2F2A'
    };

    // Whichever room's text/sub-label/icons should currently render in the
    // live preview — the single-sign fields in single mode, or the room
    // that's focused/selected in the bulk rooms table.
    // ---- variant lookup: Option1=Size, Option2=Material, Option3=Mounting ----
    const variantMap = {};
    productData.variants.forEach(v=>{
      variantMap[v.size + '|' + v.material + '|' + v.mounting] = v;
    });

    function findVariant(){
      const key = SIZES[state.size].label + '|' + MATERIALS[state.material].label + '|' + MOUNTINGS[state.mounting].label;
      return variantMap[key] || null;
    }

    function escapeXml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    function iconPath(id, color){
      const stroke = `stroke="${color}" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"`;
      switch(id){
        case 'man': return `<g transform="translate(0.000,0.000) scale(0.064704)"><g fill="${color}"><path d="M188.434,315.146c11.767,0,21.31-9.534,21.315-21.301c0.009-0.004,0.028-130.165,0.028-130.165
			c0-1.224,0.99-2.218,2.219-2.218h4.513c1.224,0,2.219,0.99,2.219,2.218c0,0,0,365.168,0,365.211
			c0,15.181,12.307,27.487,27.487,27.487c15.181,0,27.487-12.307,27.487-27.487c0-0.043,0-214.884,0-214.884
			c0-1.568,0.727-2.219,2.271-2.219h4.432c1.549,0,2.271,0.655,2.271,2.219c0,0,0,214.846,0,214.884
			c0,15.181,12.308,27.487,27.488,27.487c15.18,0,27.487-12.307,27.487-27.487c0-0.043,0-365.211,0-365.211
			c0-1.224,0.989-2.218,2.218-2.218h4.514c1.225,0,2.219,0.99,2.219,2.218c0,0,0.02,130.161,0.028,130.165
			c0.01,11.767,9.549,21.301,21.315,21.301c11.771,0,21.319-9.543,21.319-21.319c0-0.067,0-146.359,0-148.104
			c0-29.17-22.443-51.614-50.49-51.614c-0.712,0-38.417,0-56.099,0c0,0-3.543,0-8.974,0c-17.681,0-55.386,0-56.098,0
			c-28.052,0-50.49,22.438-50.49,51.614c0,1.745,0,148.037,0,148.104C167.114,305.604,176.658,315.146,188.434,315.146z"/><circle cx="278.192" cy="40.904" r="40.904"/></g></g>`;
        case 'woman': return `<g transform="translate(9.000,0.000) scale(0.028125)"><g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="${color}"><path d="M3040 12786 c-438 -78 -765 -396 -854 -829 -19 -91 -22 -272 -6 -369
54 -340 298 -652 613 -785 165 -69 212 -78 417 -77 172 0 191 2 275 28 183 55
326 139 453 265 363 359 413 913 121 1337 -59 85 -180 204 -268 264 -92 62
-217 118 -329 146 -120 32 -309 40 -422 20z"/><path d="M2285 10435 c-293 -47 -542 -177 -751 -391 -178 -183 -280 -362 -367
-649 -30 -99 -115 -376 -187 -615 -73 -239 -181 -595 -240 -790 -59 -195 -167
-551 -240 -790 -72 -239 -150 -493 -172 -563 -71 -230 -81 -315 -53 -436 31
-130 117 -235 240 -293 118 -55 278 -49 385 14 49 29 126 105 160 158 38 59
54 104 149 425 419 1413 673 2267 707 2383 l25 82 110 0 c101 0 110 -2 105
-17 -10 -33 -122 -421 -326 -1128 -213 -738 -430 -1494 -660 -2290 -76 -264
-200 -693 -275 -954 -75 -260 -139 -480 -142 -487 -4 -12 100 -14 656 -14
l661 0 0 -1818 c0 -1263 3 -1836 11 -1878 43 -236 262 -398 514 -381 226 16
400 159 444 365 8 38 11 568 11 1892 l0 1840 145 0 144 0 3 -1857 c3 -1849 3
-1858 24 -1914 46 -126 117 -211 221 -267 147 -78 338 -81 484 -7 67 35 158
121 192 183 60 111 57 -5 57 2004 l0 1838 660 0 c368 0 660 4 660 9 0 4 -13
53 -29 107 -29 98 -99 339 -291 999 -169 582 -589 2029 -790 2720 -106 363
-218 749 -249 858 l-58 197 119 0 c86 0 120 -3 123 -12 2 -7 53 -179 114 -383
60 -203 168 -566 239 -805 72 -239 198 -664 282 -945 83 -280 165 -551 181
-602 35 -106 86 -190 153 -251 218 -200 568 -106 675 182 27 73 37 192 22 271
-6 33 -140 483 -297 1000 -717 2356 -657 2168 -740 2308 -185 308 -476 551
-779 651 -190 63 -140 60 -1085 62 -670 2 -883 0 -945 -11z"/></g></g>`;
        case 'access': return `<g transform="translate(1.294,0.000) scale(0.028125)"><g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="${color}"><path d="M4120 12795 c-8 -2 -49 -9 -90 -15 -83 -14 -275 -77 -354 -117 -350
-176 -577 -531 -611 -953 -19 -243 66 -534 209 -713 l54 -68 6 -517 c3 -284 8
-881 11 -1327 9 -1324 24 -2926 31 -3285 l6 -335 192 2 c105 1 454 7 776 13
1641 31 2689 29 3083 -4 97 -9 188 -18 200 -21 28 -7 -37 123 614 -1230 985
-2043 1402 -2897 1447 -2957 11 -15 25 -12 167 41 230 86 429 169 894 371 696
303 1053 450 1091 450 22 0 29 46 28 185 -3 270 -51 496 -133 624 -57 88 -117
110 -231 87 -70 -15 -135 -42 -526 -215 -276 -122 -545 -208 -712 -227 l-58
-6 -133 273 c-231 472 -430 886 -851 1769 -224 470 -507 1063 -630 1318 l-223
462 -1954 0 -1953 0 -10 24 c-38 100 -59 365 -41 511 12 103 43 229 71 293
l19 42 1440 0 1441 0 0 510 0 510 -37 2 c-21 1 -596 2 -1278 3 -984 1 -1279 5
-1427 16 -103 8 -189 17 -192 20 -21 21 -33 1083 -20 1769 l6 325 77 75 c47
47 158 133 291 225 331 230 464 373 525 569 30 92 51 343 40 466 -47 514 -495
960 -1035 1030 -70 9 -186 11 -220 5z"/><path d="M2283 8130 c-627 -344 -1159 -826 -1552 -1405 -389 -574 -629 -1216
-690 -1850 -6 -60 -16 -171 -23 -245 -18 -193 -15 -601 6 -780 126 -1064 639
-2016 1471 -2731 691 -594 1537 -936 2692 -1088 619 -82 1339 18 1993 276 450
178 873 430 1270 755 144 118 451 421 560 553 41 50 112 126 156 170 126 124
174 238 175 416 2 289 -163 654 -411 913 l-96 99 -59 -94 c-444 -708 -1005
-1271 -1625 -1632 -350 -203 -780 -358 -1190 -428 -159 -27 -558 -38 -737 -19
-664 67 -1305 344 -1838 792 -110 92 -330 314 -420 423 -300 364 -535 823
-650 1271 -206 797 -96 1673 299 2377 190 340 460 654 726 847 210 151 254
216 249 368 -5 149 -4 239 5 497 9 278 -1 382 -50 478 -22 45 -83 127 -94 127
-3 0 -78 -41 -167 -90z"/></g></g>`;
        case 'audio': return `<g transform="scale(0.049150)"><g transform="translate(-33.552374,765.800857) scale(0.100000,-0.100000)"
fill="${color}" stroke="none">
<path d="M6235 7647 c-140 -46 -235 -176 -235 -320 0 -84 30 -144 133 -270
212 -260 355 -482 491 -762 286 -585 413 -1203 373 -1810 -17 -269 -15 -320
18 -394 32 -71 96 -135 170 -171 138 -67 329 3 407 147 34 63 45 123 59 323
23 326 0 748 -60 1080 -130 716 -450 1397 -934 1990 -85 104 -118 134 -182
167 -60 31 -176 41 -240 20z"/>
<path d="M3085 6990 c-139 -17 -269 -42 -373 -71 -388 -109 -731 -309 -1013
-589 -298 -297 -496 -630 -614 -1035 -44 -150 -23 -254 71 -355 65 -69 139
-103 229 -104 105 -1 167 24 241 98 60 60 62 63 108 206 89 278 215 489 411
686 252 253 523 405 850 475 156 33 431 38 594 10 343 -58 648 -218 901 -471
153 -153 239 -271 330 -455 124 -252 165 -427 165 -710 -1 -214 -13 -296 -72
-480 -148 -463 -468 -834 -888 -1030 -219 -103 -264 -126 -355 -186 -123 -81
-324 -281 -402 -399 -175 -265 -249 -495 -267 -835 -6 -93 -17 -197 -26 -229
-59 -222 -233 -404 -460 -482 -67 -23 -97 -28 -185 -28 -166 0 -292 44 -427
150 -102 80 -139 98 -203 98 -74 -1 -146 -39 -233 -122 -88 -86 -122 -153
-121 -242 1 -118 48 -185 212 -303 195 -140 428 -224 685 -247 254 -22 524 46
764 193 287 175 487 426 588 739 45 139 62 240 70 418 7 168 25 267 66 364 58
136 168 270 285 347 34 21 125 68 203 103 332 151 505 268 747 510 320 319
523 674 628 1096 135 539 78 1074 -168 1575 -165 335 -404 625 -698 845 -319
239 -653 379 -1064 445 -115 19 -474 28 -579 15z"/>
<path d="M5565 6907 c-96 -32 -163 -91 -204 -177 -22 -46 -26 -69 -26 -140 0
-107 16 -141 119 -270 242 -300 390 -599 490 -996 56 -219 68 -328 75 -664 6
-303 7 -317 29 -358 35 -67 98 -129 161 -159 48 -24 68 -28 141 -28 74 0 92 4
143 30 73 37 139 108 168 183 20 51 23 81 27 275 7 318 -19 555 -94 858 -117
479 -364 979 -654 1328 -68 82 -151 123 -258 128 -46 2 -93 -3 -117 -10z"/>
<path d="M3025 5904 c-203 -36 -374 -105 -547 -220 -106 -71 -135 -106 -164
-205 -35 -116 0 -272 79 -351 80 -80 236 -111 348 -69 31 12 80 40 110 62 69
53 197 113 274 130 136 29 324 5 442 -55 66 -33 158 -107 210 -169 195 -232
204 -588 19 -830 -74 -97 -102 -192 -86 -289 20 -121 65 -185 169 -236 68 -33
83 -37 155 -37 95 0 145 14 207 54 120 80 275 383 325 638 24 119 24 375 1
492 -37 182 -105 349 -202 496 -214 323 -559 541 -939 594 -105 15 -303 12
-401 -5z"/>
<path d="M3257 4990 c-104 -27 -179 -89 -226 -190 -37 -78 -37 -191 0 -270 78
-167 272 -241 434 -167 78 36 137 95 170 170 73 162 0 360 -160 433 -60 28
-159 38 -218 24z"/>
<path d="M2570 4317 c-57 -17 -141 -79 -177 -131 -97 -141 -69 -336 65 -441
69 -55 126 -75 208 -75 262 0 422 295 279 512 -36 53 -118 115 -177 133 -58
17 -146 18 -198 2z"/>
<path d="M1553 3979 c-71 -27 -155 -106 -190 -177 -23 -47 -28 -70 -28 -132 0
-139 8 -149 437 -577 435 -433 429 -428 576 -421 103 5 133 19 213 95 76 72
103 133 103 233 0 133 4 127 -437 567 -365 364 -396 392 -450 412 -73 27 -155
27 -224 0z"/>
<path d="M1257 2990 c-104 -27 -179 -89 -226 -190 -37 -78 -37 -191 0 -270 78
-167 272 -241 434 -167 78 36 137 95 170 170 73 162 0 360 -160 433 -60 28
-159 38 -218 24z"/>
<path d="M570 2317 c-57 -17 -141 -79 -177 -131 -97 -141 -69 -336 65 -441 69
-55 126 -75 208 -75 262 0 422 295 279 512 -36 53 -118 115 -177 133 -58 17
-146 18 -198 2z"/>
</g></g>`;
        case 'nosmoking': return `<g transform="scale(0.043760)"><g transform="translate(-2.171468,825.530283) scale(0.100000,-0.100000)"
fill="${color}" stroke="none">
<path d="M3795 8250 c-727 -55 -1490 -333 -2090 -764 -255 -183 -635 -542
-816 -771 -506 -639 -799 -1403 -860 -2240 -15 -206 -6 -688 16 -845 176
-1288 878 -2374 1954 -3025 888 -537 1947 -718 2967 -506 621 128 1141 363
1653 746 617 461 1074 1083 1361 1853 200 534 297 1171 261 1706 -59 875 -360
1665 -887 2326 -141 176 -472 508 -644 645 -600 477 -1361 785 -2135 866 -137
14 -633 20 -780 9z m614 -631 c500 -48 889 -159 1296 -368 354 -182 595 -354
869 -621 508 -495 834 -1107 980 -1840 44 -220 56 -348 56 -596 0 -618 -120
-1126 -383 -1624 -80 -153 -164 -293 -246 -409 -107 -155 -135 -191 -148 -188
-7 1 -329 317 -716 702 -2578 2567 -4032 4011 -4048 4023 -34 24 -128 142
-123 155 7 19 133 114 259 194 534 341 981 500 1595 567 157 17 457 19 609 5z
m-2203 -1948 c1865 -1852 4169 -4158 4169 -4173 0 -21 -154 -142 -315 -250
-267 -177 -518 -300 -821 -402 -634 -213 -1293 -243 -1934 -86 -274 67 -481
143 -727 266 -683 342 -1216 879 -1563 1573 -346 694 -449 1515 -284 2271 54
244 104 404 202 640 115 277 216 444 502 831 17 24 36 39 46 37 9 -2 336 -320
725 -707z"/>
<path d="M3745 7038 c-79 -28 -107 -89 -160 -353 -33 -158 -43 -364 -26 -485
35 -235 172 -496 332 -631 144 -121 262 -176 461 -215 49 -9 94 -22 102 -28 8
-6 26 -51 41 -101 33 -111 80 -214 132 -291 97 -143 293 -285 488 -353 l100
-35 325 -7 c206 -4 340 -11 365 -19 23 -7 57 -30 81 -55 52 -53 64 -103 64
-255 0 -98 2 -110 19 -120 11 -5 73 -10 139 -10 167 0 168 0 165 155 -3 202
-49 323 -167 440 -40 39 -98 84 -131 102 -120 63 -133 65 -455 69 -339 5 -393
13 -520 75 -145 72 -265 212 -310 364 -6 22 -15 90 -20 150 -9 124 -20 157
-59 175 -14 7 -84 16 -156 21 -71 5 -165 17 -208 28 -234 61 -398 233 -466
494 -44 167 -38 310 25 602 41 193 43 239 12 259 -17 11 -138 41 -142 35 -1 0
-14 -5 -31 -11z"/>
<path d="M4559 6609 c-19 -19 -21 -30 -18 -134 3 -75 8 -117 18 -128 11 -14
33 -17 120 -17 285 0 451 -51 575 -176 92 -94 126 -171 126 -288 0 -100 -23
-177 -80 -273 -28 -45 -50 -91 -50 -101 0 -24 46 -87 93 -129 45 -39 94 -48
231 -39 131 8 335 -8 406 -32 176 -61 344 -186 436 -323 106 -160 125 -240
133 -581 8 -316 2 -301 114 -306 83 -4 149 10 178 39 18 18 19 34 19 227 0
224 -12 327 -57 482 -75 262 -256 503 -474 634 -186 110 -335 156 -536 163
-79 3 -143 8 -143 10 0 3 7 33 17 67 22 81 22 241 0 325 -36 136 -136 289
-251 383 -194 159 -378 217 -693 218 -132 0 -145 -2 -164 -21z"/>
<path d="M5103 3954 c-7 -19 56 -88 227 -249 41 -38 163 -155 270 -260 273
-266 349 -332 361 -314 14 23 12 812 -3 827 -9 9 -118 12 -430 12 -372 0 -419
-2 -425 -16z"/>
<path d="M6130 3900 c-19 -19 -20 -33 -20 -422 0 -222 4 -409 8 -416 7 -9 45
-12 158 -10 l149 3 3 407 c1 249 -2 416 -8 432 l-10 26 -130 0 c-117 0 -132
-2 -150 -20z"/>
<path d="M6590 3901 c-6 -13 -10 -165 -10 -425 0 -390 1 -406 19 -416 33 -17
243 -13 269 6 l22 15 0 386 0 385 -34 34 -34 34 -111 0 c-99 0 -111 -2 -121
-19z"/>
<path d="M1501 3960 c-69 -17 -66 5 -69 -465 -3 -417 -2 -425 18 -445 l20 -20
1505 2 c1196 2 1507 6 1517 16 10 10 -4 29 -72 98 -47 47 -139 136 -205 197
-103 95 -205 191 -565 534 -36 34 -79 68 -95 75 -24 10 -229 13 -1025 15 -547
1 -1010 -2 -1029 -7z"/>
</g></g>`;
        default: return '';
      }
    }

    // ---- grade-1 braille transliteration (real dots, not decorative) ----
    // Standard 6-dot cell numbering:  1 4
    //                                 2 5
    //                                 3 6
    const BRAILLE_LETTERS = {
      a:[1], b:[1,2], c:[1,4], d:[1,4,5], e:[1,5], f:[1,2,4], g:[1,2,4,5], h:[1,2,5], i:[2,4], j:[2,4,5],
      k:[1,3], l:[1,2,3], m:[1,3,4], n:[1,3,4,5], o:[1,3,5], p:[1,2,3,4], q:[1,2,3,4,5], r:[1,2,3,5], s:[2,3,4], t:[2,3,4,5],
      u:[1,3,6], v:[1,2,3,6], w:[2,4,5,6], x:[1,3,4,6], y:[1,3,4,5,6], z:[1,3,5,6]
    };
    const BRAILLE_DIGIT_LETTER = {'1':'a','2':'b','3':'c','4':'d','5':'e','6':'f','7':'g','8':'h','9':'i','0':'j'};
    const BRAILLE_NUMBER_SIGN = [3,4,5,6];

    // digits get the number-sign cell once per run, then a/b/c... stand in for 1/2/3...;
    // letters map directly; anything else (space, punctuation) becomes a blank cell
    function textToBrailleCells(text){
      const cells = [];
      let numberMode = false;
      for (const ch of String(text||'')){
        if (/[0-9]/.test(ch)){
          if (!numberMode){ cells.push(BRAILLE_NUMBER_SIGN); numberMode = true; }
          cells.push(BRAILLE_LETTERS[BRAILLE_DIGIT_LETTER[ch]]);
        } else if (/[a-zA-Z]/.test(ch)){
          numberMode = false;
          cells.push(BRAILLE_LETTERS[ch.toLowerCase()] || []);
        } else {
          numberMode = false;
          cells.push([]);
        }
      }
      return cells;
    }
    function brailleMarkup(text, cx, cy, color, dotR, dotGap, cellGap){
      const cells = textToBrailleCells(text);
      if (!cells.length) return '';
      const cellWidth = dotGap + cellGap;
      const totalWidth = cells.length*cellWidth - cellGap;
      const positions = { 1:[0,0], 2:[0,1], 3:[0,2], 4:[1,0], 5:[1,1], 6:[1,2] };
      let x = cx - totalWidth/2, out = '';
      cells.forEach(dotsInCell=>{
        dotsInCell.forEach(d=>{
          const [col,row] = positions[d];
          out += `<circle cx="${x+col*dotGap}" cy="${cy+row*dotGap}" r="${dotR}" fill="${color}"/>`;
        });
        x += cellWidth;
      });
      return out;
    }

    // ---- WCAG contrast ratio — a practical, checkable proxy for ADA's
    // qualitative "high contrast, non-glare finish" requirement (ADA itself
    // doesn't cite this exact formula, but it's a reasonable stand-in) ----
    function hexToRgb(hex){
      hex = String(hex).replace('#','');
      if (hex.length===3) hex = hex.split('').map(c=>c+c).join('');
      const num = parseInt(hex,16);
      return [(num>>16)&255, (num>>8)&255, num&255];
    }
    function relLuminance(hex){
      const [r,g,b] = hexToRgb(hex).map(v=>{
        v/=255;
        return v<=0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055,2.4);
      });
      return 0.2126*r+0.7152*g+0.0722*b;
    }
    function contrastRatio(hex1,hex2){
      const L1=relLuminance(hex1), L2=relLuminance(hex2);
      const lighter=Math.max(L1,L2), darker=Math.min(L1,L2);
      return (lighter+0.05)/(darker+0.05);
    }

    function archPathD(x,y,w,h){
      const topY = y + h*0.24;
      return `M ${x} ${y+h} L ${x} ${topY} A ${w/2} ${topY-y} 0 0 1 ${x+w} ${topY} L ${x+w} ${y+h} Z`;
    }
    function wavyPathD(x,y,w,h){
      const iw = w*0.06;
      return `M ${x+iw} ${y} L ${x+w-iw} ${y} C ${x+w-iw*2.4} ${y+h*0.3}, ${x+w-iw*2.4} ${y+h*0.7}, ${x+w-iw} ${y+h} L ${x+iw} ${y+h} C ${x+iw*2.4} ${y+h*0.7}, ${x+iw*2.4} ${y+h*0.3}, ${x+iw} ${y} Z`;
    }
    function diagonalPathD(x,y,w,h){
      const cut = Math.min(w,h)*0.22;
      return `M ${x} ${y} L ${x+w-cut} ${y} L ${x+w} ${y+cut} L ${x+w} ${y+h} L ${x} ${y+h} Z`;
    }
    function bowedPathD(x,y,w,h){
      // straight on three sides, left edge bows outward in a gentle convex curve
      const b = w*0.09;
      return `M ${x+b} ${y} Q ${x-w*0.05} ${y+h/2} ${x+b} ${y+h} L ${x+w} ${y+h} L ${x+w} ${y} Z`;
    }
    function shapeMarkup(shape, x, y, w, h, attrs, rx){
      rx = (rx===undefined) ? 6 : rx;
      switch(shape){
        case 'oval': return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${w/2}" ry="${h/2}" ${attrs}/>`;
        case 'circle': { const r=Math.min(w,h)/2; return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${r}" ry="${r}" ${attrs}/>`; }
        case 'arch': return `<path d="${archPathD(x,y,w,h)}" ${attrs}/>`;
        case 'wavy': return `<path d="${wavyPathD(x,y,w,h)}" ${attrs}/>`;
        case 'bowed': return `<path d="${bowedPathD(x,y,w,h)}" ${attrs}/>`;
        case 'diagonal': return `<path d="${diagonalPathD(x,y,w,h)}" ${attrs}/>`;
        default: return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${rx}" ${attrs}/>`;
      }
    }
    function standoffPoints(shape, x, y, w, h){
      if (shape==='circle' || shape==='oval'){
        const rx = (shape==='circle') ? Math.min(w,h)/2 : w/2;
        const ry = (shape==='circle') ? Math.min(w,h)/2 : h/2;
        const cx = x+w/2, cy = y+h/2, k = 0.78;
        return [45,135,225,315].map(deg=>{
          const rad = deg*Math.PI/180;
          return [cx + rx*k*Math.cos(rad), cy + ry*k*Math.sin(rad)];
        });
      }
      const inset = (shape==='rectangle') ? 18 : Math.max(w,h)*0.09;
      if (shape==='arch'){
        // Top of the plate is cut away by the arc except at the very center
        // (see archPathD) — the flat vertical sides don't start until topY,
        // so top standoffs need to sit at/below that line, not at a generic
        // top-corner inset (which landed in the cut-away area above the arc).
        const topY = y + h*0.24;
        return [[x+inset, topY+inset], [x+w-inset, topY+inset], [x+inset, y+h-inset], [x+w-inset, y+h-inset]];
      }
      if (shape==='diagonal'){
        // Top-right corner is sliced off by a diagonal cut (see diagonalPathD)
        // — shift that standoff left, off the missing corner and onto the
        // sign's actual top edge.
        const cut = Math.min(w,h)*0.22;
        return [[x+inset, y+inset], [x+w-cut-inset, y+inset], [x+inset, y+h-inset], [x+w-inset, y+h-inset]];
      }
      if (shape==='bowed'){
        // Left edge bows outward from x+b rather than running straight down
        // x (see bowedPathD) — left standoffs need to start from that bowed
        // edge, not from the plain rectangle inset (which sat left of the
        // actual plate edge, off the sign).
        const b = w*0.09;
        const leftX = x + b + inset*0.5;
        return [[leftX, y+inset], [x+w-inset, y+inset], [leftX, y+h-inset], [x+w-inset, y+h-inset]];
      }
      return [[x+inset,y+inset],[x+w-inset,y+inset],[x+inset,y+h-inset],[x+w-inset,y+h-inset]];
    }
    // ---- accent style overlays (drawn on top of / behind the base plate) ----
    function accentColorHex(){
      return state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].hex;
    }
    function offsetShadowMarkup(shape, px, py, w, h, color){
      const dx = w*0.055, dy = h*0.07;
      return shapeMarkup(shape, px+dx, py+dy, w, h, `fill="${color}"`, 6);
    }
    function accentOverlayMarkup(accent, px, py, w, h, color){
      switch(accent){
        case 'stripe':
          return `<rect x="${px}" y="${py}" width="${w*0.16}" height="${h}" fill="${color}"/>`;
        case 'bands': {
          const bandH = h*0.15;
          return `<rect x="${px}" y="${py}" width="${w}" height="${bandH}" fill="${color}"/>
                  <rect x="${px}" y="${py+h-bandH}" width="${w}" height="${bandH}" fill="${color}"/>`;
        }
        case 'split':
          return `<polygon points="${px+w},${py} ${px+w},${py+h} ${px+w*0.35},${py+h}" fill="${color}"/>`;
        case 'banner': {
          const y0 = py+h*0.32, y1 = py+h*0.46;
          return `<path d="M ${px} ${y0+h*0.06} C ${px+w*0.3} ${y0-h*0.08}, ${px+w*0.7} ${y0+h*0.1}, ${px+w} ${y0-h*0.02}
                   L ${px+w} ${y1-h*0.02} C ${px+w*0.7} ${y1+h*0.1}, ${px+w*0.3} ${y1-h*0.08}, ${px} ${y1+h*0.06} Z"
                   fill="${color}" opacity="0.92"/>`;
        }
        default: return '';
      }
    }
    // Acrylic is the only material now, and it's always custom-colored — a
    // flat, slightly glossy fill rather than any of the old drawn textures.
    function materialFillDefs(uid, customColor){
      const c = customColor || '#C6A05F';
      return `<linearGradient id="fill-${uid}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c}"/><stop offset="1" stop-color="${c}"/></linearGradient>`;
    }
    function shadowFilter(mounting){
      const isStandoff = mounting==='standoff';
      const dx = isStandoff?10:3, dy = isStandoff?14:4, b = isStandoff?10:3;
      return `filter:drop-shadow(${dx}px ${dy}px ${b}px rgba(0,0,0,0.45))`;
    }

    function buildChipRow(container, options, key, disableFn){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (disableFn && disableFn(k, opt)) btn.classList.add('disabled');
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (btn.classList.contains('disabled')) return;
          state[key] = k;
          render();
        });
        container.appendChild(btn);
      });
    }

    // Icons are multi-select (a sign can carry Accessible + No Smoking + Audio
    // Accessible all at once) — "None" is a clear-all action rather than a
    // normal member of the selection array.

    let lastRestroomType = state.restroomType;

    function render(){
      const shapeName = state.shape;
      if (ACCENTS[state.accent].incompatibleShapes && ACCENTS[state.accent].incompatibleShapes.includes(shapeName)){
        state.accent = 'none';
      }
      // Backplate is sold as the "Offset Shadow" accent — picking that look IS
      // the paid backplate add-on, so Material (which is what actually prices
      // the variant) tracks the accent choice rather than being picked
      // separately. This only works because there's one thickness (1/8")
      // in play; if a second thickness returns, Material needs to encode
      // both thickness and backplate again.
      state.material = (state.accent==='shadow') ? 'backplate' : 'standard';
      // Every sign we sell is ADA-compliant now — no toggle, no non-compliant
      // option. Typeface is locked to sans-serif per §703.2.2.
      if (state.typeface!=='sans'){
        state.typeface = 'sans';
      }

      const size = SIZES[state.size];
      const typeface = TYPEFACES[state.typeface];
      const plateW = 320, plateH = plateW * (size.h/size.w);
      const vbW = plateW+120, vbH = plateH+120;
      const px = (vbW-plateW)/2, py = (vbH-plateH)/2;
      const uid = state.material;
      const clipId = 'clip-' + sectionId + '-' + uid;

      let defs = materialFillDefs(uid, state.plateColor);
      const plateFill = `url(#fill-${uid})`;
      const overlay = '';
      defs += `<clipPath id="${clipId}">${shapeMarkup(shapeName, px, py, plateW, plateH, '', 6)}</clipPath>`;

      let standoffs = '';
      if (state.mounting==='standoff'){
        standoffs = standoffPoints(shapeName, px, py, plateW, plateH)
          .map(([cx,cy])=>`<circle cx="${cx}" cy="${cy}" r="5" fill="#8E7442"/><circle cx="${cx}" cy="${cy}" r="2" fill="#C6A05F"/>`).join('');
      }
      const glow = '';

      if (!state.textColorManual){
        state.textColor = MATERIALS[state.material].engrave;
      }
      const engraveColor = state.textColor;
      // Both current materials are acrylic (just different thickness), so the
      // lighter stroke always applies — revisit if a non-acrylic option is added.
      const plateStroke = 'rgba(255,255,255,0.6)';
      const plateShadow = shadowFilter(state.mounting);

      // ---- accent overlays: offset shadow draws BEHIND the plate; the rest draw
      // on top, clipped to the plate's own outline so nothing spills past the edge ----
      const accentColorValue = accentColorHex();
      const shadowBehindMarkup = state.accent==='shadow'
        ? offsetShadowMarkup(shapeName, px, py, plateW, plateH, accentColorValue) : '';
      const onTopAccentMarkup = (state.accent!=='none' && state.accent!=='shadow')
        ? accentOverlayMarkup(state.accent, px, py, plateW, plateH, accentColorValue) : '';

      const textColor = engraveColor;

      // Auto-suggest label text when the restroom type changes, unless the
      // customer has typed their own — same pattern as the color-manual flag.
      if (state.restroomType !== lastRestroomType){
        if (!state.labelManual) state.labelText = RESTROOM_TYPES[state.restroomType].defaultLabel;
        lastRestroomType = state.restroomType;
      }
      const labelDisplay = state.labelText.toUpperCase();

      const AVG_CHAR_WIDTH_RATIO = { serif:0.60, sans:0.62, script:0.52 };
      const charRatio = AVG_CHAR_WIDTH_RATIO[state.typeface] || 0.6;

      // Each non-rectangular shape curves inward differently — a flat margin
      // is only safe for shapes with straight sides. Wavy pinches in by
      // ~14.4% of width at the vertical middle (exactly where content sits),
      // and arch's dome narrows above ~24% of height, so both need their own
      // clearance instead of one shared percentage.
      const SIDE_MARGIN = { rectangle:0.06, oval:0.14, circle:0.14, porthole:0.14, arch:0.06, wavy:0.19, bowed:0.07, diagonal:0.06 };
      const TOP_MARGIN  = { arch:0.30 };
      const sideMarginFrac = SIDE_MARGIN[shapeName] ?? 0.06;
      const minTopFrac = TOP_MARGIN[shapeName] || 0;

      // stripe/bands accents carve out dedicated space, so keep content
      // clear of those zones rather than drawing on top of them
      const hasStripe = state.accent==='stripe';
      const hasBands = state.accent==='bands';
      const contentLeft = px + plateW*(hasStripe ? Math.max(0.16, sideMarginFrac) : sideMarginFrac);
      const contentTop = py + plateH*Math.max(hasBands ? 0.15 : 0, minTopFrac);
      const contentBottom = py + plateH*(1 - (hasBands ? 0.15 : 0));
      const contentRight = px + plateW*(1-sideMarginFrac);
      const cx = (contentLeft+contentRight)/2;
      const usableW = (contentRight-contentLeft) * 0.98;
      const usableH = contentBottom - contentTop;

      // Real physical scale: plateW px corresponds to size.w inches, so every
      // measurement below uses the actual ADA figures at this sign's true
      // scale rather than an arbitrary percentage of the plate.
      const pxPerInch = plateW / size.w;
      const inchPx = (n) => n * pxPerInch;

      const topMargin = inchPx(0.5);
      const bottomMargin = inchPx(0.5);
      const gapPictoToText = inchPx(0.5);
      const gapTextToBraille = inchPx(0.375); // §703.3.1 minimum, shown at its actual value
      const brailleDotR = inchPx(0.0615/2);
      const brailleDotGap = inchPx(0.0925);
      const brailleCellGap = inchPx(0.2705);
      const brailleBlockH = brailleDotGap*2 + brailleDotR*2;

      // Character height must be 5/8"–2" per §703.2.4. Real signage keeps
      // ONE fixed height across a whole restroom-sign set — MEN, WOMEN,
      // RESTROOM, a custom "FAMILY", etc. should all read at the same size.
      // Defaulting each label to the ADA-max and only shrinking when THAT
      // word doesn't fit isn't actually uniform: "WOMEN" is wider than
      // "MEN" at the same height, so on a narrow plate it would correctly
      // shrink to avoid overflow while "MEN" stayed at full size — visibly
      // different sizes, even though neither individually overflowed.
      // Instead, size for the WIDEST of the standard labels once, and use
      // that same shared size for whichever one is currently showing, so
      // Men/Women/Unisex are always identical — only a custom label wider
      // than "WOMEN" (e.g. "FAMILY RESTROOM") falls back to shrinking
      // further, and only for itself.
      const minCharHeight = inchPx(0.625);
      const maxCharHeight = inchPx(2.0);
      const STANDARD_LABELS = Object.keys(RESTROOM_TYPES).map(k=>RESTROOM_TYPES[k].defaultLabel);
      let uniformFontSize = maxCharHeight;
      STANDARD_LABELS.forEach(lbl=>{
        uniformFontSize = Math.min(uniformFontSize, fitFontSizeByMeasurement(lbl, usableW*0.92, maxCharHeight, 8, typeface.family, typeface.weight));
      });
      let labelFontSize = uniformFontSize;
      if (measureTextWidth(labelDisplay, labelFontSize, typeface.family, typeface.weight) > usableW*0.92){
        labelFontSize = fitFontSizeByMeasurement(labelDisplay, usableW*0.92, uniformFontSize, 8, typeface.family, typeface.weight);
      }

      // Lay out bottom-up from the plate's own bottom margin, so every gap
      // above is the real measurement rather than back-solved from guesses.
      const brailleBottom = contentBottom - bottomMargin;
      const brailleY = brailleBottom - brailleDotR - brailleDotGap*2;
      const textBottom = (brailleY - brailleDotR) - gapTextToBraille;
      const labelY = textBottom - labelFontSize*0.22;
      const textTop = labelY - labelFontSize*0.78;
      const pictoZoneBottom = textTop - gapPictoToText;
      const pictoZoneTop = contentTop + topMargin;

      // Pictogram(s) stack ABOVE the label — matching real restroom signage
      // convention — rather than beside it like Common Room's icon-forward
      // layout, since that's how every reference example does it.
      const pictoKeys = state.restroomType==='men' ? ['man']
        : state.restroomType==='women' ? ['woman']
        : ['man','woman'];
      if (state.includeAccessible==='on') pictoKeys.push('access');

      // Icons must render at ONE consistent size regardless of how many are
      // shown — real ADA restroom signage keeps the Men/Women figures (and
      // the Accessible symbol, when added) at a fixed height and simply
      // spaces more of them across the row, rather than shrinking each one
      // as more are added. Fill the picto field's height first; only fall
      // back to a width-based cap in the rare case that would make a full
      // row of icons wider than the plate.
      // Each icon's artwork is drawn in a shared 36×36 unit box, but the
      // actual glyph doesn't fill that box equally — man/woman are narrow
      // silhouettes with large built-in side margins (~10 units each side),
      // while the wheelchair symbol fills nearly the full width (~1.3-unit
      // margins). Spacing the BOXES evenly therefore didn't space the
      // GLYPHS evenly. These margins (measured via SVG getBBox()) let us
      // position by true visual edge instead. The Accessible symbol also
      // renders at its own smaller scale (subordinate to the Man/Woman
      // figures per direction) rather than matching their full height.
      const ICON_MARGIN = { man:10.813, woman:9.734, access:1.311 };
      const ICON_SCALE = { man:1, woman:1, access:0.7 };

      // Lay out the row at a given "base" size (Man/Woman's height; smaller
      // icons scale off that same base) and report how wide the whole row
      // comes out — used both to find the largest size that fits, and to
      // actually build the final markup once that size is found.
      function layoutRow(baseSize){
        const gap = baseSize*0.22;
        let cursor = 0;
        const items = pictoKeys.map(key=>{
          const size = baseSize * (ICON_SCALE[key] ?? 1);
          const marginPx = (ICON_MARGIN[key]||0) * (size/36);
          const boxX = cursor - marginPx;
          const glyphW = size - marginPx*2;
          cursor += glyphW + gap;
          return { key, boxX, size };
        });
        return { items, totalW: cursor - gap };
      }

      const pictoZoneH = pictoZoneBottom - pictoZoneTop;
      // Binary search the largest base size whose actual row width (from the
      // real per-icon geometry above, not a rough per-icon estimate) still
      // fits usableW — this is what reclaims the space the old conservative
      // formula was leaving unused.
      let lo = inchPx(0.75), hi = pictoZoneH, pictoSize = lo;
      for (let i=0;i<20;i++){
        const mid = (lo+hi)/2;
        if (layoutRow(mid).totalW <= usableW){ pictoSize = mid; lo = mid; } else { hi = mid; }
      }

      const { items: glyphItems, totalW: pictoTotalW } = layoutRow(pictoSize);
      const rowOffset = cx - pictoTotalW/2;
      const pictoMarkup = glyphItems.map(({key, boxX, size})=>{
        const px0 = boxX + rowOffset;
        const boxY = (pictoZoneTop+pictoZoneBottom)/2 - size/2;
        return iconImages[key]
          ? `<image href="${iconImages[key]}" x="${px0}" y="${boxY}" width="${size}" height="${size}"/>`
          : `<g transform="translate(${px0}, ${boxY}) scale(${size/36})">${iconPath(key, textColor)}</g>`;
      }).join('');

      const content = `
        ${pictoMarkup}
        <text x="${cx}" y="${labelY}" text-anchor="middle" font-family="${typeface.family}" font-weight="${typeface.weight}" font-style="${typeface.italic?'italic':'normal'}" font-size="${labelFontSize}" fill="${textColor}">${escapeXml(labelDisplay)}</text>
        ${state.labelText ? brailleMarkup(state.labelText, cx, brailleY, textColor, brailleDotR, brailleDotGap, brailleCellGap) : ''}
      `;

      const svg = `
        <svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Restroom sign preview">
          <defs>${defs}</defs>
          ${glow}
          ${shadowBehindMarkup}
          ${shapeMarkup(shapeName, px, py, plateW, plateH, `fill="${plateFill}" style="${plateShadow}" stroke="${plateStroke}" stroke-width="1"`, 6)}
          ${overlay}
          <g clip-path="url(#${clipId})">${onTopAccentMarkup}</g>
          ${standoffs}
          ${content}
        </svg>`;

      const stage = document.getElementById('rs-stage');
      let holder = stage.querySelector('.ss-svg-holder');
      if (!holder){
        holder = document.createElement('div');
        holder.className = 'ss-svg-holder';
        stage.insertBefore(holder, stage.querySelector('.rs-stage-caption'));
      }
      holder.innerHTML = svg;

      document.getElementById('rs-stage-dims').textContent = `${size.w}" × ${size.h}" — Restroom`;
      document.getElementById('rs-stage-mount').textContent = MOUNTINGS[state.mounting].label;

      const textColorEl = root.querySelector('#rs-textColor');
      if (textColorEl && document.activeElement !== textColorEl) textColorEl.value = state.textColor;
      const labelEl = root.querySelector('#rs-labelText');
      if (labelEl && document.activeElement !== labelEl) labelEl.value = state.labelText;

      buildChipRow(root.querySelector('#rs-restroomTypeRow'), RESTROOM_TYPES, 'restroomType');
      buildChipRow(root.querySelector('#rs-accessibleRow'), ACCESSIBLE_MODES, 'includeAccessible');
      buildChipRow(root.querySelector('#rs-shapeRow'), SHAPES, 'shape');
      buildChipRow(root.querySelector('#rs-typefaceRow'), TYPEFACES, 'typeface', (k)=>{
        return k!=='sans';
      });
      buildChipRow(root.querySelector('#rs-sizeRow'), SIZES, 'size');
      buildChipRow(root.querySelector('#rs-mountingRow'), MOUNTINGS, 'mounting');
      buildChipRow(root.querySelector('#rs-accentRow'), ACCENTS, 'accent', (k,opt)=>{
        return !!(opt.incompatibleShapes && opt.incompatibleShapes.includes(shapeName));
      });
      const showAccentColor = ACCENTS[state.accent].needsColor;
      root.querySelector('#rs-accentColorField').style.display = showAccentColor ? '' : 'none';
      if (showAccentColor){
        buildChipRow(root.querySelector('#rs-accentColorRow'), ACCENT_COLORS, 'accentColor');
        root.querySelector('#rs-accentCustomColorField').style.display = (state.accentColor==='custom') ? '' : 'none';
      }

      // ---- ADA compliance is now standard on every sign, so nothing about
      // it is surfaced to the customer. These checks still run internally
      // (silently) rather than being deleted outright — character height and
      // pictogram field size are real physical failure modes (a sign can end
      // up genuinely out of spec depending on text length / size chosen), so
      // keeping the computation available for a future non-customer-facing
      // use (e.g. an internal QA flag before fabrication) seemed safer than
      // losing the check entirely. ----
      const contrastPass = contrastRatio(state.textColor, state.plateColor) >= 4.5;
      const pictoInches = pictoSize / pxPerInch;
      const pictoMeetsField = pictoInches >= 5.99; // 6" minimum, tiny epsilon for float rounding
      const charHeightInches = labelFontSize / pxPerInch;
      const charHeightPass = charHeightInches >= 0.625;
      const complianceEl = root.querySelector('#rs-complianceCheck');
      if (complianceEl) complianceEl.style.display = 'none';

      // ---- price from the matched real Shopify variant ----
      const variant = findVariant();
      const priceEl = document.getElementById('rs-priceValue');
      const unavailableEl = document.getElementById('rs-unavailable');
      const addBtn = document.getElementById('rs-addBtn');
      if (variant){
        priceEl.textContent = variant.price;
        if (!variant.available){
          unavailableEl.textContent = 'This combination is currently out of stock.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (!state.labelText.trim()){
          unavailableEl.textContent = 'Add label text first.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else {
          unavailableEl.style.display = 'none';
          addBtn.disabled = false;
        }
      } else {
        priceEl.textContent = '—';
        unavailableEl.textContent = "This exact combination isn't available yet — try a different size or mounting.";
        unavailableEl.style.display = '';
        addBtn.disabled = true;
      }
    }

    function bindTextInputs(){
      [['rs-plateColor','plateColor'],
       ['rs-accentCustomColor','accentCustomColor']].forEach(([id,key])=>{
        const el = root.querySelector('#'+id);
        if (!el) return;
        el.value = state[key];
        el.addEventListener('input', e=>{ state[key] = e.target.value; render(); });
      });
      const labelEl = root.querySelector('#rs-labelText');
      if (labelEl){
        labelEl.value = state.labelText;
        labelEl.addEventListener('input', e=>{
          state.labelText = e.target.value;
          state.labelManual = true;
          render();
        });
      }
      const textColorEl = root.querySelector('#rs-textColor');
      if (textColorEl){
        textColorEl.value = state.textColor;
        textColorEl.addEventListener('input', e=>{
          state.textColor = e.target.value;
          state.textColorManual = true;
          render();
        });
      }
    }

    function addToCart(){
      const variant = findVariant();
      if (!variant || !variant.available || !state.labelText.trim()) return;
      const errorEl = document.getElementById('rs-error');
      const addBtn = document.getElementById('rs-addBtn');
      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      const properties = {
        'Restroom Type': RESTROOM_TYPES[state.restroomType].label,
        'Label Text': state.labelText,
        'Accessible Symbol': state.includeAccessible==='on' ? 'Yes' : 'No',
        'Shape': SHAPES[state.shape].label,
        'Typeface': TYPEFACES[state.typeface].label,
        'Shape Color': state.plateColor,
        'Text Color': state.textColor
      };
      if (state.accent!=='none'){
        properties['Accent Style'] = ACCENTS[state.accent].label;
        properties['Accent Color'] = state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].label;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: properties }] })
      })
      .then(res => res.json().then(body => ({ ok: res.ok, body })))
      .then(({ ok, body })=>{
        addBtn.disabled = false;
        if (!ok){
          errorEl.textContent = (body && body.description) || 'Could not add this to your cart. Please try again.';
          errorEl.style.display = '';
          addBtn.textContent = originalLabel;
          return;
        }
        addBtn.textContent = 'Added ✓';
        addBtn.classList.add('ss-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: body } }));
        setTimeout(()=>{ addBtn.classList.remove('ss-added'); render(); }, 1800);
      })
      .catch(()=>{
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
        errorEl.textContent = 'Network error — please try again.';
        errorEl.style.display = '';
      });
    }

    root.querySelector('#rs-addBtn').addEventListener('click', addToCart);

    bindTextInputs();
    render();
    iconImagesReady.then(render);
  }
})();
